import { Box, Typography } from '@material-ui/core';
import { TimelineItemProps } from './__types';
import { useLocation } from 'react-router-dom';
import { ESCOLA_ETAPAS_PARAMS_URL } from 'models/escola';
import './styles.scss'

export const TimelineItem = ({
  icon,
  isActive,
  isCompleted,
  label,
  isThird,
  isSecond,
  onClick
}: TimelineItemProps) => {
  const location = useLocation();
  const cadastro = location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.CADASTRO);

  const labelCompleteClass = isCompleted
    ? 'completedLabel'
    : 'inactive';
  const iconContainerClass = isActive
    ? 'active'
    : labelCompleteClass
  const labelClass = isActive
    ? 'activeLabel'
    : labelCompleteClass;

  return (
    <Box
      onClick={onClick}
      className={`timelineItemContainer 
      ${cadastro ? '' : 'cursorPointer'}
      ${isSecond ? 'secondItem' : ''}
      ${isThird ? 'thirdItem' : ''} `}
    >
      <Box className={`iconContainer ${iconContainerClass}`}>{icon}</Box>
      <Typography className={`label ${labelClass}`}>{label}</Typography>
    </Box>
  );
};
